export const orderViewsFavoriteFirst = <T extends { is_favorite?: boolean }>(
  views: ReadonlyArray<T>,
): Array<T> => {
  const favoriteViewIndex = views.findIndex(view => view.is_favorite);

  if (favoriteViewIndex === -1) return [...views];

  return [views[favoriteViewIndex], ...views.filter((_, index) => index !== favoriteViewIndex)];
};
